
import React from 'react';
import classNames from 'classnames';
import Immutable from 'immutable';
import { Paragraph } from '@uncinc/react-drupal-core';
import {
  Image,
} from '@uncinc/uncinc-react-kitchen-sink';
import i18next from '../../../../config/i18next';


import {
  Container,
  WysiwygField,
  Breadcrumbs,
  Share,
} from '../../../../components';

import BasicPageRelatedItems from '../RelatedItems';

import './style.scss';

const NodeBasicPageFull = ({ entity, className }) => {
  const classes = classNames(className, 'BasicPage');
  const relatedItems = entity.get('field_related');
  const id = entity.getIn(['nid', 0, 'value']);

  if (!entity.getIn(['title', 0, 'value']) && !entity.getIn(['body', 0, 'processed'])) {
    return null;
  }

  return (
    <article typeof="schema:WebPage" className={classes}>
      <Container small>
        <Breadcrumbs includeCurrent />
        <div className="BasicPage">
          <h1 className="BasicPage__title">{entity.getIn(['title', 0, 'value'])}</h1>

          {entity.getIn(['body', 0, 'processed']) ? (
            <WysiwygField
              property="schema:text"
              className="BasicPage__body"
              html={entity.getIn(['body', 0, 'processed'], '')}
            />
          ) : null}

          {entity.getIn(['field_image'], Immutable.List()).size > 0 && (
            <div className="BasicPage__image">
              <Image
                src={{
                  0: entity.getIn(['field_image', 0, 'styles', 'large']),
                  768: entity.getIn(['field_image', 0, 'styles', 'basic_image']),
                }}
                includeWebP
              />
            </div>
          )}
        </div>
      </Container>
      <div className="Paragraphs">
        {
          entity.getIn(['field_paragraphs'], Immutable.List()).map((item, index) => {
            const paragraphId = item.get('target_id');
            const paragraph = item.getIn(['entity']);
            return (
              <Paragraph key={paragraphId} entity={paragraph} id={paragraphId} />
            );
          })
        }
      </div>

      <Container small>
        <Share title={i18next.t('share')} />
      </Container>

      <BasicPageRelatedItems relatedItems={relatedItems} id={id} />
    </article>
  );
};

export default NodeBasicPageFull;
